import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverList, deleteServer, changeServerRegisterFlag } from "@/api/gmtool/packageCode";
import addserver from "./components/addserver.vue";
import modifyingRecords from "./components/modifyingRecords.vue";
import { gmTool } from "@/mixins/index";
export default {
  name: "serverLisy",
  components: {
    addserver: addserver,
    modifyingRecords: modifyingRecords
  },
  mixins: [gmTool],
  data: function data() {
    return {
      isPrize: false,
      prizeList: [],
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      paramsData: {
        page: 1
      },
      isCode: false,
      codeLists: [],
      SelectionList: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    changeLogin: function changeLogin(row) {
      var _this2 = this;

      var params = {
        is_prod: this.paramsData.is_prod,
        server_id: row.serverID,
        flag: row.register_flag
      };
      changeServerRegisterFlag(params).then(function (res) {
        if (res.code == 200) {
          _this2.$message({
            type: "success",
            message: _this2.$t('operationSuccess')
          });
        }

        _this2.getList();
      });
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.paramsData.page = val;
      this.getList();
    },
    getList: function getList() {
      var _this3 = this;

      this.reqLoading = true;
      serverList(this.paramsData).then(function (res) {
        if (res.status == 200) {
          // this.list = res.data || [];
          var originalList = res.data || [];
          var serverNameMap = new Map();
          originalList.forEach(function (item) {
            if (item.serverID !== undefined) {
              serverNameMap.set(item.serverID, item.serverName);
            }
          });
          _this3.list = originalList.map(function (item) {
            var mainServerName = '';

            if (item.merge_to_sid) {
              mainServerName = serverNameMap.get(item.merge_to_sid) || '/';
            } else {
              mainServerName = '/';
            }

            return _objectSpread(_objectSpread({}, item), {}, {
              mainServerName: mainServerName
            });
          });
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.SelectionList = e;
    },
    // 删除配置
    handleDelete: function handleDelete(data) {
      var _this4 = this;

      this.$confirm(this.$t('confirmDeleteServerData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = data.map(function (item) {
                  return item.id;
                });
                deleteServer({
                  ids: id
                }).then(function (res) {
                  _this4.$message({
                    type: "success",
                    message: _this4.$t('deleteSuccess')
                  });

                  setTimeout(function () {
                    _this4.getList();
                  }, 500);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};